import script from "./MultiSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&setup=true"

import "./MultiSelect.vue?vue&type=style&index=0&id=783350b1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783350b1"]])

export default __exports__